module.exports = __webpack_public_path__ + "img/gs.a7244d3f.svg";